import { render } from "./GroupDetail.vue?vue&type=template&id=3ef20522&scoped=true&ts=true"
import script from "./GroupDetail.vue?vue&type=script&lang=ts"
export * from "./GroupDetail.vue?vue&type=script&lang=ts"

import "./GroupDetail.vue?vue&type=style&index=0&id=3ef20522&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef20522"]])

export default __exports__